import styled from "styled-components";

import type { FontVariant } from "@similarweb/styles";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { CenteredFlexColumn, FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const carbon500 = colorsPalettes.carbon[500];
const carbon250 = colorsPalettes.carbon[250];
const red100 = colorsPalettes.red.s100;
const bodyFont: FontVariant = "body2";
const subtitleFont: FontVariant = "subtitle1";

interface IStyledFlexColumnProps {
    color: string;
    marginBottom?: number;
    font?: FontVariant;
}

const createStyledFlexColumn = ({ color, marginBottom = 0, font }: IStyledFlexColumnProps) => styled(FlexColumn)`
    ${font ? `${setFontVariant(font, color)};` : `color: ${color};`}
    ${marginBottom && `margin-bottom: ${marginBottom}px;`}
`;

export const WizardButtonsWrapper = styled(FlexRow)`
    width: 100%;
    height: 68px;
    justify-content: end;
    align-items: center;
    box-sizing: border-box;
    & > *:first-child {
        margin-right: 4px;
    }
`;

export const WizardWrapper = styled(FlexColumn)`
    overflow-y: scroll;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
`;

export const LineBreak = styled.div`
    margin-top: 48px;
`;

export const WizardContainer = styled(CenteredFlexColumn)`
    box-shadow: 0 3px 6px rgba(14, 30, 62, 0.08);
    border-radius: 6px;
    background-color: ${colorsPalettes.carbon[0]};
    margin-bottom: 80px;
    align-items: stretch;
`;

export const WizardLegendWrapper = styled(FlexColumn)<{ legendItemsLength: number }>`
    justify-content: center;
    width: ${({ legendItemsLength }) => (legendItemsLength > 3 ? `760` : `450`)}px;
    padding: 0 24px;
    box-sizing: border-box;
`;

export const CurrentPageWrapper = styled(FlexRow)`
    flex: 1 1 0;
    height: fit-content;
`;

export const FooterWrapper = styled(FlexRow)`
    position: fixed;
    bottom: 0;
    justify-content: center;
    width: 100%;
    background-color: ${colorsPalettes.carbon[0]};
    border-top: 1px solid ${colorsPalettes.carbon[100]};
    /* This is to fix table Antd last cell overflow the footer */
    z-index: 4;
`;

export const FooterContent = styled(FlexRow)<{ width: number }>`
    width: ${({ width = 700 }) => `${width}px`};
    justify-content: space-between;
`;

export const KeywordsCampaignGenericStepWrapper = styled(FlexColumn)`
    justify-content: start;
    box-sizing: border-box;
    padding: 32px;
    width: 700px;
    min-height: 632px;
`;

export const PopupHoverContainerContentWrapper = styled(FlexColumn)``;

export const PopupHoverContainerRowWrapper = styled(FlexRow)<{ font?: FontVariant }>`
    justify-content: space-between;
`;
export const PopupHoverContainerKeywordCountLabel = createStyledFlexColumn({
    color: carbon500,
    marginBottom: 16,
    font: subtitleFont,
});
export const PopupHoverContainerTotalBalanceLabel = createStyledFlexColumn({
    color: carbon250,
    marginBottom: 8,
});
export const PopupHoverContainerAvailableLabel = createStyledFlexColumn({
    color: carbon250,
    marginBottom: 24,
});
export const PopupHoverContainerExplainLabel = createStyledFlexColumn({
    color: carbon250,
    marginBottom: 0,
});

export const PopupHoverContainerUsedNowLabel = styled(
    createStyledFlexColumn({ color: carbon500, marginBottom: 4, font: subtitleFont }),
)<{ isMaxAllowKeywords: boolean }>`
    ${({ isMaxAllowKeywords }) => setFontVariant("listItem1", isMaxAllowKeywords ? red100 : carbon500)};
`;

export const PopupHoverContainerBoldValue = styled.div<{ isMaxAllowKeywords: boolean }>`
    ${({ isMaxAllowKeywords }) => setFontVariant(subtitleFont, isMaxAllowKeywords ? red100 : carbon500)};
`;
export const PopupHoverContainerStandardValue = styled.div<{ isMaxAllowKeywords: boolean }>`
    ${({ isMaxAllowKeywords }) => setFontVariant(bodyFont, isMaxAllowKeywords ? red100 : carbon250)};
`;

export const PopupHoverContainerChildrenWrapper = styled.div``;
export const KeywordsCounterComponentWrapper = styled.div`
    padding-left: 10px;
`;
